var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "channel-list-item",
      class: { "channel-list-item-sm": _vm.windowIsSmall },
      style: [
        _vm.verticalPadding,
        { borderTop: "1px solid " + _vm.$themePalette.grey.v_200 },
      ],
    },
    [
      _c("ChannelDetails", {
        attrs: { channel: _vm.channel, channelVersion: _vm.versionNumber },
        scopedSlots: _vm._u(
          [
            _vm.multipleMode
              ? {
                  key: "beforethumbnail",
                  fn: function () {
                    return [
                      _c("KCheckbox", {
                        staticClass: "checkbox",
                        attrs: {
                          label: _vm.channel.name,
                          showLabel: false,
                          checked: _vm.$attrs.checked,
                        },
                        on: {
                          change: function ($event) {
                            return _vm.$emit("checkboxchange", {
                              channel: _vm.channel,
                              isSelected: $event,
                            })
                          },
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
            _vm.isUnlistedChannel
              ? {
                  key: "belowname",
                  fn: function () {
                    return [
                      _c(
                        "KTooltip",
                        {
                          attrs: {
                            reference: "lockicon",
                            refs: _vm.$refs,
                            placement: "top",
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.deviceString("unlistedChannelLabel")) +
                              "\n      "
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "private-icons" },
                        [
                          _c("KIcon", {
                            ref: "lockicon",
                            staticClass: "lock-icon",
                            attrs: { icon: "unlistedchannel" },
                          }),
                          _vm.channel.newUnlistedChannel
                            ? _c("NewBadge", {
                                staticClass: "new-label",
                                attrs: {
                                  label: _vm.deviceString("newChannelLabel"),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "abovedescription",
              fn: function () {
                return [
                  _vm.newVersionAvailable
                    ? _c(
                        "div",
                        [
                          _c("KIcon", {
                            staticClass: "update-icon",
                            style: { fill: _vm.$themeTokens.primary },
                            attrs: { icon: "error" },
                          }),
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$tr("newVersionMessage")) +
                              "\n        "
                          ),
                          _c("KRouterLink", {
                            attrs: {
                              to: _vm.newChannelVersionPageRoute,
                              text: _vm.$tr("moreInformationLabel"),
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.onDevice
                    ? _c(
                        "div",
                        { staticClass: "on-device" },
                        [
                          _c("KIcon", {
                            staticClass: "check-icon",
                            style: { fill: _vm.$themeTokens.success },
                            attrs: { icon: "correct" },
                          }),
                          _c("span", { staticClass: "on-device-text" }, [
                            _vm._v(_vm._s(_vm.$tr("onYourDevice"))),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "append",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "col-3" },
                    [
                      _vm.multipleMode && _vm.$attrs.checked
                        ? _c("p", { staticClass: "selected-msg" }, [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.channelSelectedMessage) +
                                "\n        "
                            ),
                          ])
                        : _vm._e(),
                      !_vm.multipleMode
                        ? _c("KRouterLink", {
                            attrs: {
                              text: _vm.$tr("selectResourcesAction"),
                              to: _vm.selectContentLink,
                              appearance: "raised-button",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }